// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b10cec52","453":"59be7fcc","455":"2faa08de","644":"31ed65b7"}[chunkId] + ".chunk.js";
};